import { Pipe, PipeTransform } from '@angular/core';
import { StatisticsExtractor } from 'app/trello/utility/statistics-extractor';

@Pipe({
  name: 'total',
  pure: true,
})
export class TotalPipe implements PipeTransform {

  constructor(
    private readonly statisticsExtractor: StatisticsExtractor,
  ) {
  }

  transform(
    values: {
      [outerGroup: string]: {
        [innerGroup: string]: number,
      },
    } | undefined,
  ): number | undefined {
    return this.statisticsExtractor.aggregateTotal(values);
  }

}
